import { createContext, useContext } from "react";
import { DEFAULT_SUPPLIER, Supplier } from "./suppliers";

/** 當前瓦斯行透過 context 傳給各入口/註冊頁，各頁用 useSupplier() 取用。 */
export const SupplierContext = createContext<Supplier>(DEFAULT_SUPPLIER);

export const useSupplier = (): Supplier => useContext(SupplierContext);
